import { render, staticRenderFns } from "./StatsPoliza.vue?vue&type=template&id=2213f4fd&scoped=true"
import script from "./StatsPoliza.vue?vue&type=script&lang=js"
export * from "./StatsPoliza.vue?vue&type=script&lang=js"
import style0 from "./StatsPoliza.vue?vue&type=style&index=0&id=2213f4fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2213f4fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanelContent,VRow})
